// extracted by mini-css-extract-plugin
module.exports = {"animated":"styles-module--animated--2aBSC"};